import {Column} from "@tanstack/react-table";
import {CSSProperties} from "react";

export const getCommonHeaderStyles = <T>(column: Column<T>, isDragging: boolean, transform: string | undefined, isCell: boolean = false): CSSProperties => {

    const isPinned = column.getIsPinned()
    const isGrouped = column.getIsGrouped()
    const isLastLeftPinnedColumn =
        isPinned === 'left' && column.getIsLastColumn('left')
    const isFirstRightPinnedColumn =
        isPinned === 'right' && column.getIsFirstColumn('right')

    return {
        boxShadow: isLastLeftPinnedColumn
            ? '-4px 0 4px -4px gray inset'
            : isFirstRightPinnedColumn
                ? '4px 0 4px -4px gray inset'
                : undefined,
        left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
        right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
        opacity: isDragging ? 0.8 : isPinned ? 0.95 : 1,
        position: isPinned ? 'sticky' : !isCell ? 'relative' : 'unset',
        width: column.getSize(),
        zIndex: isPinned || isDragging ? isCell ? 2 : 3 : 0,
        backgroundColor: isDragging ? "#b8b8b8" : isPinned ? "white" : isGrouped ? "#b8b8b8" : "transparent",
        transform: transform, // translate instead of transform to avoid squishing
        transition: 'width transform 0.2s ease-in-out',
        whiteSpace: 'nowrap',
        alignContent: 'center',
    }
}
